import { appstr } from "../utils/appstr";
import { enumIconStr, enumPanelBorderStyle, kIDDSmallButtonHeight, kIDDWidth } from "../constants";
import { QIDDButton } from "./QIDDButton";
import { QPanel } from "./QPanel";

export class QIconDropDown extends QPanel {
  constructor() {
    super();
    this.fBaseCode = null;
    this.fCmdList = null;
    this.fDefWidth = null;
    this.fWSMgr = null;
  }

  ButtonEnabled(buttonIndex) {
    return true;
  }

  CalcDDHeight(numItems) {
    var iddHeight = numItems * (kIDDSmallButtonHeight + 2) + 2;
    return iddHeight;
  }

  InitIconDropDown(
    baseCode,
    wsMgr,
    optionList,
    hoverList,
    cmdList,
    iconList,
    doLookup,
    defaultWidth // , selectedRoots)
  ) {
    this.fWSMgr = wsMgr;
    if (defaultWidth == null) defaultWidth = kIDDWidth;

    var numItems = optionList.length;
    var iddHeight = this.CalcDDHeight(numItems);

    this.SizePanel(defaultWidth, iddHeight);
    this.SetModalOn(true);
    this.SetOutsideClickDismissOn(true);
    this.fUIColors = wsMgr.GetUIColors();
    this.SetFillColor(this.fUIColors.GetSecondaryPanelFillColor());
    this.SetShadowOn(true);
    this.SetBorderStyle(enumPanelBorderStyle.singleBorder);
    this.fBaseCode = baseCode; // + "-";
    this.fTextColor = this.fUIColors.GetHeaderTextColor();

    var imageMgr = wsMgr.GetImageMgr();

    var elementPosY1;

    this.fCmdList = cmdList;
    var kIDDButtonWidth = defaultWidth - 4;
    for (var y = 0; y < numItems; y++) {
      var sButton = new QIDDButton();
      sButton.fTextColor = this.fTextColor;
      sButton.fCenterIcon = false;
      elementPosY1 = y * (kIDDSmallButtonHeight + 2) + 2;
      sButton.PositionElement(2, elementPosY1);
      sButton.SizeElement(kIDDButtonWidth, kIDDSmallButtonHeight);
      var buttonCmdCode2 = this.fBaseCode + "-";
      buttonCmdCode2 = buttonCmdCode2.concat(y);

      var iconNum = enumIconStr[iconList[y]];
      sButton.SetImages(imageMgr, iconNum);
      var v;
      if (doLookup) v = appstr(optionList[y]);
      else v = optionList[y];

      var hStr = null;
      if (hoverList) hStr = hoverList[y];

      sButton.SetButtonInfo(v, hStr);
      sButton.SetCmdCode(buttonCmdCode2);

      var enabled = this.ButtonEnabled(y);
      sButton.SetEnabled(enabled);
      this.PushElement(sButton);
    }
  }

  ExecuteCommand(aCmd) {
    var cmdCode = aCmd.GetCmdCode();
    var wsMgr = aCmd.GetWSMgr();
    var panelHandled = false;

    var subCode2 = cmdCode.substring(0, this.fBaseCode.length);
    var sLen = cmdCode.length;

    if (subCode2 == this.fBaseCode) {
      var menuItemIndex = cmdCode.substring(this.fBaseCode.length + 1, sLen);
      var index = parseInt(menuItemIndex);
      var whichSelect = this.fCmdList[index];
      aCmd[this.fBaseCode] = whichSelect;
      wsMgr.RemovePanel(this);
      panelHandled = true;
    }

    switch (cmdCode) {
      case "CNCL":
        wsMgr.RemovePanel(this);
        panelHandled = true;
        break;
    }

    return panelHandled;
  }

  AutoPosition(backGround, extraHeight, x, y, width, numRows) {
    var canvasWidth = backGround.GetPositionX() + backGround.fWidth - 4;
    var canvasHeight = backGround.GetPositionY() + backGround.fHeight + extraHeight - 4;

    var pickerRight = x + width;
    if (pickerRight > canvasWidth) x = x - (pickerRight - canvasWidth);

    var iddHeight = this.CalcDDHeight(numRows);
    var pickerBottom = y + iddHeight;
    if (pickerBottom > canvasHeight) y = y - (pickerBottom - canvasHeight);

    this.PositionPanel(x, y);
  }
}
